import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavListCommonProps } from 'src/app/components/nav/nav.component';
import { environment } from 'src/environments/environment';
import { GroupBy } from '../_enums/groupby';
import { ResourceTypeCodes } from '../_enums/resource.type.codes';
import { SiteMapUrl } from '../_enums/sitemap.url';
import { Ceu } from '../_models/ceu';
import { Transport } from '../_models/transport';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TransportService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {}

  getAll(groupBy?: string, versionId?: string) {
    let params = new HttpParams();
    params = groupBy ? params.set('groupBy', groupBy) : params;
    params = versionId ? params.set('versionId', versionId) : params;

    return this.http.get<Transport[]>(`${environment.apiUrl}/Transports`, { params: params, headers: this.authService.headers });
  }

  get(resourceId: string) {
    return this.http.get<Transport>(`${environment.apiUrl}/Transports/${resourceId}`, { headers: this.authService.headers });
  }

  getCeu(resourceId: string, versionId?: string) {
    let params = new HttpParams();
    params = versionId ? params.set('versionId', versionId) : params;
    return this.http.get<Ceu>(`${environment.apiUrl}/Transports/${resourceId}/CEU`, {
      params: params,
      headers: this.authService.headers
    });
  }

  addCeu(ceu: Ceu, resourceId: string) {
    return this.http.post<Ceu>(`${environment.apiUrl}/Transports/${resourceId}/CEU`, ceu, { headers: this.authService.headers });
  }

  update(transport: Transport) {
    return this.http.put(`${environment.apiUrl}/Transports/${transport.resourceId}`, transport, { headers: this.authService.headers });
  }

  delete(resourceId: string) {
    return this.http.delete(`${environment.apiUrl}/Transports/${resourceId}`, { headers: this.authService.headers });
  }

  add(transport: Transport) {
    return this.http.post(`${environment.apiUrl}/Transports`, transport, { headers: this.authService.headers });
  }

  duplicate(resourceId: string | undefined, code: string) {
    return this.http.post(`${environment.apiUrl}/Transports/duplicate?id=${resourceId}&code=${encodeURIComponent(code)}`, null, { headers: this.authService.headers });
  }

  getNavConfig({ perimeterId }: NavListCommonProps) {
    return {
      header: {
        title: 'ressource_list_title_transports',
        actions: [{ label: 'ressource_list_action_create_transport', onClick: () => this.router.navigate([`${SiteMapUrl.MenuTransport}/new`, 0]) }],
        filters: [
          { label: 'ressource_list_filter_by_family', value: GroupBy.family },
          { label: 'ressource_list_filter_by_favorite', value: GroupBy.favorite }
        ],
        defaultFilter: GroupBy.family
      },
      getItemConfig: (node: any) => {
        return {
          displayName: `${node.displayName} [${node.code}]`,
          url: `${SiteMapUrl.MenuTransport}/${node.resourceId}`,
          state: {
            transportId: node.resourceId,
            perimeterId
          }
        };
      },
      getDataSource: this.getAll.bind(this),
      getEditableFamilyId: (node: any) => node.value?.[0].familyId,
      addFamilyType: ResourceTypeCodes.Transport
    };
  }
}
